import { Component } from '@angular/core';

@Component({
  selector: 'app-message-left-panel',
  templateUrl: './message-left-panel.component.html',
  styleUrls: ['./message-left-panel.component.css']
})
export class MessageLeftPanelComponent {

}
